import isEqual from 'react-fast-compare';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';

import { useGraphExplorer } from 'dashboard/components/GraphModule/hooks/useGraphExplorer';

export function useHoverCardState(options: {
  xTransformer?: (v: number) => number;
  yTransformer?: (v: number) => number;
}) {
  const { graphExplorer } = useGraphExplorer();

  const hoverCardX = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hoverCardX,
  );
  const hoverCardY = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hoverCardY,
  );
  const hoveredNode = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hoveredNode,
  );
  const hydratedNode = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hydratedNode,
  );
  const hydratedCollapsedNodes = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hydratedCollapsedNodes,
    isEqual,
  );
  const hoveredCollapsedGroup = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hoveredCollapsedGroup,
  );
  const hoveredCollapsedPairwiseNode = useSyncExternalStoreWithSelector(
    graphExplorer.reactSubscribe.bind(graphExplorer),
    () => graphExplorer.getSnapshot(),
    undefined,
    (snapshot) => snapshot.hoveredCollapsedPairwiseNode,
  );

  return {
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    hoverCardX: options.xTransformer ? options.xTransformer(hoverCardX) : hoverCardX,
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    hoverCardY: options.yTransformer ? options.yTransformer(hoverCardY) : hoverCardY,
    node: hoveredNode,
    hydratedNode: hydratedNode,
    collapsedGroup: hoveredCollapsedGroup,
    collapsedPairwiseNode: hoveredCollapsedPairwiseNode,
    hydratedCollapsedNodes: hydratedCollapsedNodes,
  };
}
